/**
 * Block 14 «Раскрой» — PR #1 EP-1 (CUT-1.2). Зарезервированные имена ключей
 * хранилища из TRD §0.4 (прототип vanilla).
 *
 * Решение супервайзера PR #1 §1 (вариант A): в PR #1 стор — **in-memory**
 * (паттерн `useCalculatorStore`), durable-персистенция (IndexedDB) — PR #2.
 * Эти константы фиксируют канонические имена ключей для будущего маппинга, без
 * записи проектных данных в localStorage (TRD §7.9.3 / CLAUDE.md: localStorage
 * только для UI-настроек, проектные данные → Postgres + IDB-кэш, P-007).
 */

export const CUTTING_STORAGE_KEYS = {
  drafts: 'pomoshnik_drafts',
  projects: 'pomoshnik_projects',
  offcuts: 'pomoshnik_offcuts_v1',
  partNames: 'pomoshnik_part_names_v1',
  processing: 'pomoshnik_processing_v1',
  tariffs: 'pomoshnik_tariffs_v1',
} as const;

export type CuttingStorageKey = (typeof CUTTING_STORAGE_KEYS)[keyof typeof CUTTING_STORAGE_KEYS];
